import { PostOfficesBySearchApi, PostOfficesMarkersBySearchApi } from 'graphql/generated';
import { CountryType } from 'types/country';
import { MapMarkerType } from 'types/map';
import { SearchedStoresType } from 'types/store';

export const mapPostOfficeToStore = (
    postOffice: NonNullable<PostOfficesBySearchApi['postOfficesBySearch']>[number],
): SearchedStoresType => {
    return {
        availabilities: null,
        availabilityInformation: null,
        isAvailableForProducts: null,
        isAvailableForProductsReservation: null,
        store: {
            locationLatitude: postOffice.locationLatitude,
            locationLongitude: postOffice.locationLongitude,
            city: postOffice.city,
            country: getCountryByCountryCode(postOffice.countryCode || ''),
            email: null,
            isPickupPoint: true,
            coordinateDistance: null,
            name: postOffice.name,
            postcode: postOffice.postcode,
            region: null,
            district: null,
            slug: null,
            street: postOffice.address,
            telephone: null,
            uuid: postOffice.identifier,
            openingHours: postOffice.openingHours,
        },
    };
};

export const mapPostOfficesToMapMarker = (
    postOffices: PostOfficesMarkersBySearchApi['postOfficesBySearch'] | undefined,
): MapMarkerType[] => {
    if (!postOffices) {
        return [];
    }

    return postOffices.map((postOffice) => {
        return {
            postOffice: true,
            isPickupPoint: true,
            lat: parseFloat(postOffice.locationLatitude ?? ''),
            lng: parseFloat(postOffice.locationLongitude ?? ''),
            identifier: postOffice.identifier,
        };
    });
};

export const getCountryByCountryCode = (countryCode: string): CountryType => {
    if (countryCode === 'CZ') {
        return {
            name: 'Česká republika',
            code: 'CZ',
        };
    }

    return {
        name: countryCode,
        code: countryCode,
    };
};
